import React from 'react';
import ContentWithNavigationSidebar from '../legacy/layouts/ContentWithNavigationSidebar';
import ReportsReport from '../legacy/pages/ReportsReport';
import Reports from '../legacy/pages/Reports';
import Exports from '../legacy/pages/Exports';
import ROUTE_PATH from './routePaths';

const routes = [
  {
    authenticatedRoute: true,
    path: `${ROUTE_PATH.EXPORTS}/:exportId`,
    component: props => <Exports {...props} />,
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: ROUTE_PATH.REPORTS,
    component: props => (
      <ContentWithNavigationSidebar>
        <Reports {...props} />
      </ContentWithNavigationSidebar>
    ),
  },

  {
    exact: true,
    authenticatedRoute: true,
    path: `${ROUTE_PATH.REPORTS}/:reportId`,
    component: props => (
      <ContentWithNavigationSidebar>
        <ReportsReport {...props} />
      </ContentWithNavigationSidebar>
    ),
  },
];
export default routes;



// WEBPACK FOOTER //
// ./src/routes/reportRoutes.jsx